export const RECORDING_ERROR_TOAST_TEXT =
  'Unable to load the session recording for this engagement. Live-stream details are left out of the timeline below.'
